import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const PowerPointFileFooterIcon = (props: IconProps) => (
  <Icon width="20px" height="23px" viewBox="0 0 20 23" {...props}>
    <path d="M4.397 8.096a4.001 4.001 0 0 0-.493 5.635 4.001 4.001 0 0 0 5.636.493 4.001 4.001 0 0 0 .493-5.635 4.001 4.001 0 0 0-5.636-.493Zm4.744.718-2.123 1.782-1.782-2.123a3.2 3.2 0 0 1 3.905.341Zm-4.624 4.403a3.202 3.202 0 0 1 .106-4.23l4.078 4.86a3.202 3.202 0 0 1-4.184-.63Zm4.797.115L7.532 11.21l2.124-1.782a3.201 3.201 0 0 1-.342 3.905Z" />
    <rect
      width=".667"
      height="2.667"
      x="9.667"
      y="1.247"
      stroke="#fff"
      strokeWidth=".667"
      rx=".333"
    />
    <rect
      width=".667"
      height="5.333"
      x="10.455"
      y="17.702"
      stroke="#fff"
      strokeWidth=".667"
      rx=".333"
      transform="rotate(-30 10.455 17.702)"
    />
    <rect
      width=".667"
      height="5.333"
      x="9.122"
      y="17.369"
      stroke="#fff"
      strokeWidth=".667"
      rx=".333"
      transform="rotate(30 9.122 17.369)"
    />
    <path
      fillRule="evenodd"
      d="M18.667 4.913H1.333v12h17.334v-12ZM1.333 3.58C.597 3.58 0 4.177 0 4.913v12c0 .737.597 1.334 1.333 1.334h17.334c.736 0 1.333-.597 1.333-1.334v-12c0-.736-.597-1.333-1.333-1.333H1.333Z"
      clipRule="evenodd"
    />
    <rect width="4.667" height=".667" x="12" y="8.913" rx=".333" />
    <rect width="4.667" height=".667" x="12" y="10.247" rx=".333" />
    <rect width="2.667" height=".667" x="12" y="11.58" rx=".333" />
  </Icon>
);
export default memo(PowerPointFileFooterIcon);
